module.exports = __webpack_public_path__ + "static/media/9.e4238fcf.png";